import { createTheme } from "@mui/material/styles";
import stepper from "./stepper";

const theme = createTheme({
  typography: {
    fontFamily: "inherit",
    h1: {
      fontSize: "2.5rem",
      fontWeight: 500,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: "2.125rem",
      fontWeight: 500,
      lineHeight: 1.2,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 500,
      lineHeight: 1.2,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 500,
      lineHeight: 1.2,
    },
    body1: {
      fontSize: "1.125rem",
      fontWeight: "normal",
      lineHeight: 1.22,
    },
    body2: {
      fontSize: "1rem",
      fontWeight: "bold",
      lineHeight: 1.19,
    },
    body3: {
      fontSize: "1rem",
      fontWeight: "500",
      lineHeight: 1.19,
    },
    body4: {
      fontSize: "1rem",
      fontWeight: "normal",
      lineHeight: 1.38,
    },
    body5: {
      fontSize: "0.9375rem",
      fontWeight: 600,
      lineHeight: 1.2,
    },
    body6: {
      fontSize: "0.9375rem",
      fontWeight: "normal",
      lineHeight: 1.2,
    },
    body7: {
      fontSize: "0.875rem",
      fontWeight: 500,
      lineHeight: 1.21,
    },
    body8: {
      fontSize: "0.875rem",
      fontWeight: "normal",
      lineHeight: 1.2,
    },
    caption: {
      fontSize: "0.75rem",
      fontWeight: "bold",
      lineHeight: 1.33,
    },
    caption2: {
      fontSize: "0.75rem",
      fontWeight: "normal",
      lineHeight: 1.16,
    },
    button: {
      fontSize: "1rem",
      fontWeight: "600",
      lineHeight: 1.2,
      letterSpacing: "-0.01em",
    },
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1468,
    },
  },

  palette: {
    default: {
      main: "#171717",
    },
    brand: {
      main: "#EB7406",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#ECEDEF",
          color: "#333333",
          fontSize: "1rem",
          fontFamily:
            '"SFProDisplay", Roboto, Helvetica Neue, Arial, sans-serif',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily:
            '"SFProDisplay", Roboto, Helvetica Neue, Arial, sans-serif',
        },
      },
      defaultProps: {
        variantMapping: {
          h1: "h1",
          h2: "h2",
          h3: "h3",
          h4: "h4",
          body1: "p",
          body2: "p",
          body3: "p",
          body4: "p",
          body5: "p",
          body6: "p",
          body7: "p",
          body8: "p",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "unset",
          borderRadius: "8px",
        },
      },
      variants: [
        {
          props: { size: "large" },
          style: {
            padding: "1rem",
            fontSize: "1rem",
            letterSpacing: "-0.01em",
          },
        },
        {
          props: { size: "medium" },
          style: {
            padding: "0.75rem 1rem",
            fontSize: "0.875rem",
            fontWeight: 500,
            lineHeight: 1.143,
          },
        },
        {
          props: { variant: "contained", color: "brand" },
          style: {
            backgroundColor: "#F69133",
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "#EB7406",
            },
          },
        },
        {
          props: { variant: "contained", color: "default" },
          style: {
            backgroundColor: "#333333",
            color: "white",
            "&:hover": {
              backgroundColor: "#171717",
            },
          },
        },
        {
          props: { variant: "outlined", color: "brand" },
          style: {
            border: "1px solid #F69133",
            color: "#F69133",
            "&:hover": {
              border: "1px solid #EB7406",
              backgroundColor: "#EB7406",
              color: "#fff",
            },
          },
        },
        {
          props: { variant: "outlined", color: "default" },
          style: {
            border: "1px solid #333333",
            color: "#333333",
            "&:hover": {
              border: "1px solid #171717",
              backgroundColor: "#171717",
              color: "#fff",
            },
          },
        },
      ],
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: "3px",
          borderRadius: "100px",
          backgroundColor: "#D9D9D9",
        },
        bar: {
          borderRadius: "100px",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          },
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              color: "#EB7406",
              borderColor: "#EB7406",
            },
          "& .MuiFormLabel-root.Mui-focused ": {
            color: "#EB7406",
          },
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          "& .MuiPaper-root": {
            borderRadius: "8px",
          },
        },
        backdrop: {
          background:
            "linear-gradient(106.32deg, rgba(51, 51, 51, 0.7) 1.53%, rgba(0, 0, 0, 0.7) 97.2%)",
          backdropFilter: "blur(30px)",
        },
      },
    },
    ...stepper,
  },
});

export default theme;
